import React from 'react';

function App() {
  return (
    <div style={{ fontFamily: 'sans-serif', padding: '2rem' }}>
      <h1>Welcome to ApneaStream</h1>
      <p>Phase 1 MVP is running locally ✅</p>
      <p>We’re just getting started. Sleep better, live better.</p>
    </div>
  );
}

export default App;
